module.exports = __webpack_public_path__ + "static/bailey-logo-009acdd035ce5a87ad6fb890a1d04364.png";